<template>
  <div
    :id="type || 'search-box'"
    :class="['search-wrapper', { 'opened': searchMobileOpened }, type]"
  >
    <slot />
    <button
      v-if="smallScreen"
      aria-label="Cancel"
      class="search-wrapper__cancel"
      @click="toggle(false)"
    >
      {{ cancelLabel }}
    </button>
  </div>
</template>

<script>
  import { throttle } from '@Foundation/utilities';
  import { mapActions, mapGetters } from 'vuex';

  export default {
    name: 'SearchWrapper',
    props: {
      apiUrl: { type: String, required: true },
      type: { type: String, required: true },
      cancelLabel: { type: String, required: false, default: 'Cancel' }
    },
    data() {
      return {
        smallScreen: !window.matchMedia('(min-width: 1366px)').matches,
      };
    },
    computed: {
      ...mapGetters('searchStore', [
        'searchMobileOpened'
      ])
    },
    mounted() {
      this.setApiUrl(this.apiUrl);

      /* istanbul ignore next */
      window.addEventListener('resize', throttle(() => {
        this.smallScreen = !window.matchMedia('(min-width: 1366px)').matches;
      }, 100));
    },
    methods: {
      ...mapActions('searchStore', [
        'setSearchMobileOpened',
        'setApiUrl'
      ]),
      toggle(status) {
        this.setSearchMobileOpened(status);
      }
    }
  };
</script>
